import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const TIERS = [{
  name: 'Hobby',
  price: 'Free',
  description: 'Perfect for individuals exploring AI spreadsheets.',
  features: ['Up to 3 boards', '1,000 AI prompts/month', 'Basic formulas', 'Community support'],
  cta: 'Start for free',
  highlighted: false
}, {
  name: 'Pro',
  price: '$20',
  period: '/mo',
  description: 'For professionals who need advanced modeling and data.',
  features: ['Unlimited boards', 'Unlimited AI prompts', 'Advanced AI data cleaning', 'Postgres & Stripe sync', 'Priority support'],
  cta: 'Start Pro trial',
  highlighted: true
}, {
  name: 'Team',
  price: '$60',
  period: '/user/mo',
  description: 'For teams that need collaboration and security.',
  features: ['Everything in Pro', 'Real-time multiplayer', 'Version history & branching', 'SSO & advanced roles', 'Dedicated success manager'],
  cta: 'Contact sales',
  highlighted: false
}];
export function Pricing() {
  return <section id="pricing" className="py-24 border-t border-white/5" data-id="element-193">
      <div className="max-w-7xl mx-auto px-6" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4" data-id="element-196">
            Simple, transparent pricing
          </h2>
          <p className="text-zinc-400" data-id="element-197">
            Start for free, upgrade when you need more power.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-198">
          {TIERS.map((tier, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`relative p-8 rounded-2xl border flex flex-col ${tier.highlighted ? 'bg-zinc-900/80 border-white/20 shadow-2xl shadow-emerald-500/5' : 'bg-zinc-900/30 border-white/10'}`} data-id="element-199">
              {tier.highlighted && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-white text-zinc-950 text-xs font-semibold rounded-full" data-id="element-200">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-201">
                <h3 className="text-lg font-medium text-white mb-2" data-id="element-202">
                  {tier.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-4" data-id="element-203">
                  <span className="text-4xl font-bold text-white" data-id="element-204">
                    {tier.price}
                  </span>
                  {tier.period && <span className="text-zinc-500" data-id="element-205">{tier.period}</span>}
                </div>
                <p className="text-sm text-zinc-400" data-id="element-206">{tier.description}</p>
              </div>

              <div className="flex-1 space-y-4 mb-8" data-id="element-207">
                {tier.features.map((feature, j) => <div key={j} className="flex items-start gap-3" data-id="element-208">
                    <Check size={16} className="text-emerald-500 shrink-0 mt-0.5" data-id="element-209" />
                    <span className="text-sm text-zinc-300" data-id="element-210">{feature}</span>
                  </div>)}
              </div>

              <button className={`w-full py-2.5 rounded-md text-sm font-medium transition-colors ${tier.highlighted ? 'bg-white text-zinc-950 hover:bg-zinc-200' : 'bg-zinc-800 text-white hover:bg-zinc-700'}`} data-id="element-211">
                {tier.cta}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}